import { parseUrl } from 'query-string'

import { ROUTES_WITHOUT_SESSION_FETCHING } from 'shared/consts'
import { CSRF_FIELD_NAME } from 'shared/consts/httpHeaders'
import logger from 'shared/services/logger'
import store from 'shared/store'
import { updatePageProperties } from 'shared/store/ducks/publicRuntimeConfig'
import { setUserSession } from 'shared/store/ducks/userSession'
import buildClientAPI from 'views/providers/clientAPI'

export const shouldFetchUserSession = currentPath =>
  !ROUTES_WITHOUT_SESSION_FETCHING.some(route =>
    currentPath.split('/').includes(route)
  )

const fetchUserSession = queryStr => {
  if (!shouldFetchUserSession(window.location.pathname)) {
    logger.warn(`Session fetching disabled for ${window.location.pathname}`)
    // Dispatching an empty session
    // so modules who expect user resolution can still work (crossSell, etc)
    store.dispatch(setUserSession({}))
    return
  }

  let params = {}

  const { query } = parseUrl(queryStr || window.location.search)

  if (query.expa && query.expa !== '') {
    params.expa = query.expa
  }

  const {
    pageProperties: { pzn },
  } = store.getPublicRuntimeConfig()

  if (pzn) {
    params.pzn = pzn
  }

  if (window.STORYBOOK_ENV) {
    params = null
  }

  const { clientFockService } = buildClientAPI()
  let userSession

  // TODO: use the fire/listen Event (used for crosssell)
  clientFockService
    .fetchUserSessionData({ params })
    .then(response => {
      const { data, headers: { [CSRF_FIELD_NAME]: csrfToken } = {} } = response
      // new way of doing it
      // needs to be added to components via connect
      // dispatch `updatePageProperties` first
      // b/c leads to re-render component with the wrong state

      store.dispatch(updatePageProperties({ csrfToken }))
      userSession = {
        ...data,
        subscriptionService:
          store.getState().publicRuntimeConfig.pageProperties.featureToggles
            .subscriptionServiceActive,
        isLoggedIn: true,
      }
    })
    .catch(error => {
      logger.error(`UserSessionData not fetched: ${error}`)
      userSession = {}
    })
    .finally(async () => {
      let isLoggedIn = false
      await clientFockService
        .getUserLoginStatus()
        .then(response => {
          isLoggedIn = response.data.isLoggedInUserRegistered
        })
        .catch(() => {
          logger.error('Unable to fetch user login status')
          isLoggedIn = false
        })
        .finally(() => {
          userSession = {
            ...userSession,
            isLoggedIn,
          }
        })

      store.dispatch(setUserSession(userSession))

      if (params?.expa) {
        // params could be null during testing
        fetch(`/expa?expa=${params.expa}`, {
          method: 'POST',
        })
      }
    })
}

export default fetchUserSession
